/* eslint-disable react/no-danger */
import React from 'react';
import Collapsible from '../collapsible/Collapsible';
import TooltipWithHeading from '../helpToolTip/ToolTip';
import customStyles from './customField.module.scss';
import { getSectionByItem } from '../../modules/forms/utils/helpers';
import { checkConditionalValue, imageFileExtensions, docFileExtensions } from '../../utils/helpers';


const CollapsibleSections = ({ fieldsList, getCustomFieldComponent, formatStyle, answers }) => {
    const handleUseHelpText = helpText => (
        <>
          {helpText?.description && helpText.description?.length > 0 && (
            <TooltipWithHeading
              title="Help"
              toolTip={`form.setting.newfield.helptext.${helpText.description}`}
              text={helpText.description}
              values={helpText.description}
              iconStyles={customStyles.helpTooltip}
            />
          )}
        </>
      );

    const handleSectionImage = (section) => {
      const settings = section[0]?.settings;
      if (!settings?.enableSectionHeaderImg || !settings?.sectionHeaderImgUrl) return null;

      return settings.sectionHeaderImgUrl.split(';').map((fileUrl) => {
        const ext = getExtension(fileUrl);
        const key = fileUrl;

        if (imageExts.includes(ext)) {
          return (
            <img
              key={key}
              src={fileUrl}
              alt="section-header"
              style={{
                objectFit: 'contain',
                maxWidth: '100%',
                height: 'auto',
                display: 'block',
                marginBottom: '8px'
              }}
            />
          );
        }

        if (docExts.includes(ext)) {
          return (
            <a
              key={key}
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#0d6efd',
                textDecoration: 'underline',
                display: 'block',
                marginBottom: '8px'
              }}
            >
              {fileUrl}
            </a>
          );
        }

        return null;
      });
    };

      let allSections = getSectionByItem(fieldsList || [], 'getAllSections')?.map(
        section => ((section[0]?.type === 'header' && section[0]?.conditional && !checkConditionalValue(section[0], answers))
          ? section.slice(1)
          : section)
      );

      // turn them into arrays
      const imageExts = imageFileExtensions
        .split(',')
        .map(ext => ext.trim().toLowerCase());

      const docExts = docFileExtensions
        .split(',')
        .map(ext => ext.trim().toLowerCase());

      // helper to extract extension (without the dot)
      const getExtension = (url) => {
        const match = url.match(/\.([^.?#]+)$/); // capture group after last dot
        return match ? match[1].toLowerCase() : ''; // use [1] (group), not [0]
      };
    return (
      <>
        {allSections?.length > 0
            && allSections.map(section => (
                <>
                {section?.[0]?.type === 'header'
                && !(!section?.[0].collapsible && !section[0].enable_rte && section[0]?.title === 'Forms of Identification')
                ? (
                  <>
                    {section[0]?.collapsible ? (
                      <div className={customStyles.collapseHeader} style={formatStyle ? {} : { padding: '0px 75px' }}>
                        <Collapsible
                          title={section[0]?.title} openOnMount
                          styleClasses={customStyles.header}
                          collapseDesc
                          overflowCustom
                          collapsibleHeight={'fit-content'}
                        >
                          {section[0]?.enable_rte ? (
                            <div>
                              <div className={customStyles.description} dangerouslySetInnerHTML={{ __html: section[0]?.rte_description }} />
                            </div>
                            ) : (
                            <div className={customStyles.description} style={!section[0]?.description ? { display: 'none' }: {}}>
                              <p>{section[0]?.description}</p>
                            </div>
                          )}
                          {handleSectionImage(section)}
                          <div className={`${formatStyle ? customStyles.fieldsContainer : customStyles.collapsedFields}`}>
                            {getCustomFieldComponent(section?.slice(1) || [])}
                          </div>
                        </Collapsible>
                      </div>
                    ): (
                      <>
                        <div className={customStyles.collapseHeader} style={formatStyle ? {} : { padding: '0px 75px' }}>
                            <div className={customStyles.header}>
                                {section[0]?.title}
                            </div>
                            {!section[0].enable_rte
                                ? handleUseHelpText(section[0])
                                : <div className={customStyles.descriptions} dangerouslySetInnerHTML={{ __html: section[0].rte_description }} />}
                                {handleSectionImage(section)}
                                <div className={`${formatStyle ? customStyles.fieldsContainer : customStyles.collapsedFields}`}>
                                    {getCustomFieldComponent(section?.slice(1) || [])}
                                </div>
                        </div>
                      </>
                    )}
                  </>
                )
            : getCustomFieldComponent(section)}
                </>
            ))}
      </>
    );
  };

export default CollapsibleSections;
